
























import Vue from 'vue'
import Component from 'vue-class-component'
import {ActiveUser, User} from '../types';
import {State} from 'vuex-class';
import {Prop} from 'vue-property-decorator';

@Component
export default class ActiveUsers extends Vue {
    /**
     * Lista de usuario activos en la aplicación
     */
    @State(state => state.auth.activeUsers)
    public activeUsers: ActiveUser[]

    @Prop({type: Boolean, default: false})
    public displayAll: boolean

    @State(state => state.auth.user)
    public user: User | null

    /**
     * Elimina un usuario de la lista de usuarios activos en la aplicación
     *
     * @param user
     */
    public async removeActiveUser (user: ActiveUser) {
        await this.$store.dispatch('auth/removeActiveUser', user)
        this.$emit('removed', user)
    }

    public get activeUsersWithoutCurrent (): ActiveUser[] {
        if (!this.displayAll && this.user) {
            return this.activeUsers.filter(u => u.id !== this.user!.id)
        }

        return this.activeUsers
    }
}
